/**
 * Niko's Grillhouse logo wordmark + Ionic column.
 * - tone="light"  → for use on dark backgrounds (navbar, footer)
 * - tone="dark"   → for use on light backgrounds (impressum, etc.)
 *
 * Size is controlled by `height` (in px). Width auto-scales.
 */
export default function Logo({ className = "", tone = "light", height = 44 }) {
  const src =
    tone === "dark"
      ? "/brand/nikos-logo.png"
      : "/brand/nikos-logo-dark.png";

  return (
    <div className={`inline-flex items-center ${className}`} data-testid="niko-logo">
      <img
        src={src}
        alt="Niko's Grillhouse"
        style={{ height: `${height}px`, width: "auto" }}
        className="block select-none"
        draggable="false"
      />
    </div>
  );
}
